/** "cctv" module DTO unique keys */
export enum CctvDtoKeysEnum {
  /** "Hikvision" CCTV camera list APIs base filters */
  HIKVISION_CAMERA_FILTERS_DTO = 'cctv/hikvision-camera-filters.dto',
  /** "Hikvision" CCTV camera credentials find many API query parameters */
  HIKVISION_CAMERA_FIND_MANY_QUERY_DTO = 'cctv/hikvision-camera-find-many-query.dto',
  /** "Hikvision" CCTV camera credentials find one API query parameters (additional options) */
  HIKVISION_CAMERA_FIND_ONE_QUERY_DTO = 'cctv/hikvision-camera-find-one-query.dto',
  /** "Hikvision" CCTV camera credentials response body */
  HIKVISION_CAMERA_FIND_DTO = 'cctv/hikvision-camera-find.dto',
  /** "Hikvision" CCTV camera credentials create and update APIs request body */
  HIKVISION_CAMERA_FORM_DTO = 'cctv/hikvision-camera-form.dto',
  /** "Hikvision" CCTV camera credentials list slice (JSON "page") */
  HIKVISION_CAMERA_PAGE_DTO = 'cctv/hikvision-camera-page.dto',
  /** "Hikvision" CCTV camera one vehicle APIs URL parameters */
  HIKVISION_CAMERA_VEHICLE_PARAMS_DTO = 'cctv/hikvision-camera-vehicle-params.dto',
  /** "Hikvision" CCTV camera event list API filters */
  HIKVISION_CAMERA_EVENT_FILTERS_DTO = 'cctv/hikvision-camera-event-filters.dto',
  /** "Hikvision" CCTV camera event response body */
  HIKVISION_CAMERA_EVENT_FIND_DTO = 'cctv/hikvision-camera-event-find.dto',
  /** "Hikvision" CCTV camera event list API respons body */
  HIKVISION_CAMERA_EVENT_PAGE_DTO = 'cctv/hikvision-camera-event-page.dto',
  /** "Hikvision" CCTV camera event list API query parameters */
  HIKVISION_CAMERA_EVENT_QUERY_DTO = 'cctv/hikvision-camera-event-query.dto',
  /** Transit tasks list APIs filters */
  TRANSIT_TASK_FILTERS_DTO = 'cctv/transit-task-filters.dto',
  /** Transit tasks find API query parameters */
  TRANSIT_TASK_QUERY_DTO = 'cctv/transit-task-query.dto',
  /** Transit task response body */
  TRANSIT_TASK_FIND_DTO = 'cctv/transit-task-find.dto',
  /** Transit task create/update request body */
  TRANSIT_TASK_FORM_DTO = 'cctv/transit-task-form.dto',
  /** Transit task filters for "Personal Account" mode */
  TRANSIT_TASK_PERSONAL_ACCOUNT_FILTERS_DTO = 'cctv/transit-task-personal-account-filters.dto',
  /** Transit task create/update request body */
  TRANSIT_TASK_PERSONAL_ACCOUNT_FORM_DTO = 'cctv/transit-task-personal-account-form.dto',
  /** Transit task card partial update request body */
  TRANSIT_TASK_PARTIAL_FORM_DTO = 'cctv/transit-task-partial-form.dto',
  /** Transit task card partial update request body */
  TRANSIT_TASK_PERSONAL_ACCOUNT_PARTIAL_FORM_DTO = 'cctv/transit-task-personal-account-partial-form.dto',
  /** Transit task find many API query parameters for "Personal Account" mode */
  TRANSIT_TASK_PERSONAL_ACCOUNT_QUERY_DTO = 'cctv/transit-task-personal-account-query.dto',
  /** Transit task create request body */
  TRANSIT_TASK_CREATE_DTO = 'cctv/transit-task-create.dto',
  /** Transit task list with pagination API response body */
  TRANSIT_TASK_PAGE_DTO = 'cctv/transit-task-page.dto',
  /** Transit task sums response body */
  TRANSIT_TASK_SUMS_FIND_DTO = 'cctv/transit-task-sums-find.dto',
  /** Transit task find one API query parameters */
  TRANSIT_TASK_FIND_ONE_QUERY_DTO = 'cctv/transit-task-find-one-query.dto',
  /** Car category find one API query parameters (additional options) */
  CAR_CATEGORY_FIND_ONE_QUERY_DTO = 'cctv/car-category-find-one-query.dto',
  /** Car category response body */
  CAR_CATEGORY_FIND_DTO = 'cctv/car-category-find.dto',
  /** Car category create/update request body */
  CAR_CATEGORY_FORM_DTO = 'cctv/car-category-form.dto',
  /** Car category partial update request body */
  CAR_CATEGORY_PARTIAL_FORM_DTO = 'cctv/car-category-partial-form.dto',
  /** Car category find API query parameters */
  CAR_CATEGORY_QUERY_DTO = 'cctv/car-category-query.dto',
  /** Car category list APIs filters */
  CAR_CATEGORY_FILTERS_DTO = 'cctv/car-category-filters.dto',
  /** Car category list with pagination API response body */
  CAR_CATEGORY_PAGE_DTO = 'cctv/car-category-page.dto',
  /** Resident card find one API query parameters (additional options) */
  RESIDENT_CAR_FIND_ONE_QUERY_DTO = 'cctv/resident-car-find-one-query.dto',
  /** Resident car response body */
  RESIDENT_CAR_FIND_DTO = 'cctv/resident-car-find.dto',
  /** Resident car create/update request body */
  RESIDENT_CAR_FORM_DTO = 'cctv/resident-car-form.dto',
  /** Resident car partial update request body */
  RESIDENT_CAR_PARTIAL_FORM_DTO = 'cctv/resident-car-partial-form.dto',
  /** Resident car find API query parameters */
  RESIDENT_CAR_QUERY_DTO = 'cctv/resident-car-query.dto',
  /** Resident car list APIs filters */
  RESIDENT_CAR_FILTERS_DTO = 'cctv/resident-car-filters.dto',
  /** Resident car list with pagination API response body */
  RESIDENT_CAR_PAGE_DTO = 'cctv/resident-car-page.dto',
  /** "CCTV" module settings get and set APIs response body */
  CCTV_SETTINGS_FIND_DTO = 'cctv/cctv-settings-find.dto',
  /** "CCTV" module settings set API request body */
  CCTV_SETTINGS_FORM_DTO = 'cctv/cctv-settings-form.dto',
  /** Transit task and resident car manual pass APIs common URL parameters */
  PASS_CAR_PARAMS_DTO = 'cctv/pass-car-params.dto',
  /** Visitors report APIs common filters */
  VISITORS_REPORT_FILTERS_DTO = 'cctv/visitors-report-filters.dto',
  /** Visitors report registry entry response body */
  VISITORS_REPORT_REGISTRY_ENTRY_DTO = 'cctv/visitors-report-registry-entry.dto',
  /** Visitors report registry API query parameters */
  VISITORS_REPORT_REGISTRY_QUERY_DTO = 'cctv/visitors-report-registry-query.dto',
  /** Visitors report registry API response body */
  VISITORS_REPORT_REGISTRY_DTO = 'cctv/visitors-report-registry.dto',
  /** Visitors report subtotal entry response body */
  VISITORS_REPORT_SUBTOTAL_ENTRY_DTO = 'cctv/visitors-report-subtotal-entry.dto',
  /** Visitors report subtotal API query parameters */
  VISITORS_REPORT_SUBTOTAL_QUERY_DTO = 'cctv/visitors-report-subtotal-query.dto',
  /** Visitors report subtotal API response body */
  VISITORS_REPORT_SUBTOTAL_DTO = 'cctv/visitors-report-subtotal.dto',
  /** Event report entry response body */
  EVENT_REPORT_ENTRY_DTO = 'cctv/event-report-entry.dto',
  /** Event report API query parameters */
  EVENT_REPORT_QUERY_DTO = 'cctv/event-report-query.dto',
  /** Event report API response body */
  EVENT_REPORT_DTO = 'cctv/event-report.dto',
}
